import { Controller } from 'stimulus'
import './toast_component.css'

export default class extends Controller {
  static values = { autoDismissAfter: Number }

  connect() {
    if (!this.hasAutoDismissAfterValue) return

    this.dismissTimeout = setTimeout(
      () => this.dismiss(),
      this.autoDismissAfterValue * 1000
    )
  }

  disconnect() {
    clearTimeout(this.dismissTimeout)
  }

  dismiss() {
    this.dispatch('dismissed', { prefix: 'toast' }) // → toast:dismissed
    this.element.classList.add('js-toast-dismissing')
    this.element.addEventListener(
      'transitionend',
      () => {
        if (document.startViewTransition) {
          document.startViewTransition(() => this.element.remove())
        } else {
          this.element.remove()
        }
      },
      { once: true }
    )
  }
}
